// extracted by mini-css-extract-plugin
export default {"container":"VideoMastheadSlice_container__fY-fA","content":"VideoMastheadSlice_content__8QfEf"};